export function pushToDataLayer(eventName: string, params: Record<string, any>) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...params,
  });
}